import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

import {
    selectCurrentMyTimesheetIsEditable
} from 'services/myTimesheets/selectors';

interface OwnProps {
    children: React.ReactElement;
    FallbackComponent?: React.ReactElement;
}

interface ConnectedProps {
    currentMyTimesheetIsEditable?: boolean | undefined | null;
}

type Props = OwnProps & ConnectedProps;

export class CurrentMyTimesheetIsEditable extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { currentMyTimesheetIsEditable, children, FallbackComponent } = this.props;
        if (!currentMyTimesheetIsEditable) {
            return FallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    currentMyTimesheetIsEditable: selectCurrentMyTimesheetIsEditable
});

export default connect(mapStateToProps)(CurrentMyTimesheetIsEditable);
